import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={114.019}
      height={112.176}
      viewBox="0 0 114.019 112.176"
      {...props}
    >
      <path
        data-name="Path 249"
        d="M15.538 85.011v23.97a1.512 1.512 0 001.513 1.513h3.152a1.512 1.512 0 001.513-1.513v-23.97zm0 0"
        fill="#aa493f"
      />
      <path
        data-name="Path 250"
        d="M92.412 85.011v23.97a1.512 1.512 0 001.512 1.513h3.152a1.513 1.513 0 001.513-1.513v-23.97zm0 0"
        fill="#aa493f"
      />
      <path
        data-name="Path 251"
        d="M19.729 108.981v-23.97h-4.19v23.97a1.512 1.512 0 001.513 1.513h3.152a1.509 1.509 0 00.519-.093 1.513 1.513 0 01-.994-1.42zm0 0"
        fill="#993b36"
      />
      <path
        data-name="Path 252"
        d="M96.603 108.981v-23.97h-4.19v23.97a1.512 1.512 0 001.512 1.513h3.153a1.512 1.512 0 00.519-.093 1.513 1.513 0 01-.993-1.42zm0 0"
        fill="#993b36"
      />
      <g data-name="Group 62" fill="#fec13b">
        <path
          data-name="Path 253"
          d="M61.429 9.873a6.077 6.077 0 009.839 6.89zm0 0"
        />
        <path
          data-name="Path 254"
          d="M74.205 18.819a6.076 6.076 0 009.839 6.89zm0 0"
        />
        <path
          data-name="Path 255"
          d="M86.98 27.765a6.077 6.077 0 009.839 6.89zm0 0"
        />
      </g>
      <path
        data-name="Path 256"
        d="M68.139 17.538a6 6 0 01-2.519-4.73l-4.19-2.935a6.243 6.243 0 001.964 7.665 6.042 6.042 0 005.783.576 5.774 5.774 0 01-1.038-.576zm0 0"
        fill="#f9a332"
      />
      <path
        data-name="Path 257"
        d="M80.915 26.485a6 6 0 01-2.518-4.73l-4.191-2.934a6.243 6.243 0 001.965 7.665 6.04 6.04 0 005.783.575 5.832 5.832 0 01-1.039-.576zm0 0"
        fill="#f9a332"
      />
      <path
        data-name="Path 258"
        d="M93.69 35.431a6 6 0 01-2.518-4.731l-4.191-2.934a6.243 6.243 0 001.965 7.664 6.04 6.04 0 005.783.576 5.885 5.885 0 01-1.039-.575zm0 0"
        fill="#f9a332"
      />
      <path
        data-name="Path 259"
        d="M109.356 70.809H4.771a3.055 3.055 0 00-3.046 3.046v3.046a3.055 3.055 0 003.046 3.046h104.585a3.055 3.055 0 003.046-3.046v-3.046a3.055 3.055 0 00-3.046-3.046zm0 0"
        fill="#b9e1fb"
      />
      <path
        data-name="Path 260"
        d="M9.519 76.901v-3.046a3.055 3.055 0 013.046-3.046h-7.8a3.055 3.055 0 00-3.046 3.046v3.046a3.055 3.055 0 003.046 3.046h7.8a3.054 3.054 0 01-3.046-3.046zm0 0"
        fill="#9ad3f6"
      />
      <path
        data-name="Path 261"
        d="M32.695 67.762v-3.045a3.055 3.055 0 00-3.046-3.046H4.771a3.055 3.055 0 00-3.046 3.046v3.045a3.055 3.055 0 003.046 3.046h24.877a3.055 3.055 0 003.047-3.046zm0 0"
        fill="#9ad3f6"
      />
      <path
        data-name="Path 262"
        d="M9.519 67.762v-3.045a3.055 3.055 0 013.046-3.046h-7.8a3.055 3.055 0 00-3.046 3.046v3.045a3.055 3.055 0 003.046 3.046h7.8a3.055 3.055 0 01-3.046-3.046zm0 0"
        fill="#78cbf4"
      />
      <path
        data-name="Path 263"
        d="M6.209 79.944v3.131a3.055 3.055 0 003.046 3.046h95.617a3.055 3.055 0 003.045-3.046v-3.131zm0 0"
        fill="#b7594a"
      />
      <path
        data-name="Path 264"
        d="M14.003 83.079v-3.135H6.209v3.131a3.055 3.055 0 003.046 3.046h7.8a3.055 3.055 0 01-3.052-3.042zm0 0"
        fill="#aa493f"
      />
      <path
        data-name="Path 265"
        d="M101.3 28.475a14.546 14.546 0 00-6.053-11.549L78.473 5.184a14.541 14.541 0 00-12.921-1.737zm0 0"
        fill="#ccd7f2"
      />
      <path
        data-name="Path 266"
        d="M74.869 5.41a1.472 1.472 0 01-.311-2.126 15.06 15.06 0 00-9.006.164L101.3 28.474a15.591 15.591 0 00-1.147-5.365zm0 0"
        fill="#bccced"
      />
      <path
        data-name="Path 267"
        d="M46.123 45.25H6.644a4.925 4.925 0 01-4.919-4.92V14.216a4.925 4.925 0 014.919-4.919h39.479a4.925 4.925 0 014.92 4.919v26.116a4.925 4.925 0 01-4.92 4.918zm0 0"
        fill="#dde4f7"
      />
      <path
        data-name="Path 268"
        d="M9.519 40.333V14.216a4.925 4.925 0 014.919-4.919H6.644a4.925 4.925 0 00-4.92 4.919v26.117a4.925 4.925 0 004.92 4.919h7.794a4.924 4.924 0 01-4.919-4.919zm0 0"
        fill="#ccd7f2"
      />
      <path
        data-name="Path 269"
        d="M44.324 15.371H8.442a.644.644 0 00-.644.645v22.52a.644.644 0 00.644.645h35.882a.645.645 0 00.645-.645V16.015a.645.645 0 00-.645-.644zm0 0"
        fill="#ffd200"
      />
      <path
        data-name="Path 270"
        d="M15.593 38.535v-22.52a.644.644 0 01.645-.645h-7.8a.645.645 0 00-.645.645v22.52a.645.645 0 00.645.645h7.8a.645.645 0 01-.645-.645zm0 0"
        fill="#003586"
      />
      <path
        data-name="Path 271"
        d="M20.061 23.629a.47.47 0 01-.767-.01 2.99 2.99 0 00-5.585 1.471c0 4.159 4.373 6.632 5.713 7.291a.587.587 0 00.518 0c1.34-.661 5.713-3.141 5.713-7.291a2.991 2.991 0 00-5.592-1.461zm0 0"
        fill="#ff5155"
      />
      <path
        data-name="Path 272"
        d="M19.862 23.949c0-.058 0-.114.007-.171a.465.465 0 01-.575-.159 2.99 2.99 0 00-5.585 1.471c0 4.159 4.373 6.632 5.713 7.291a.584.584 0 00.518 0 13.67 13.67 0 003.48-2.457c-1.674-1.24-3.558-3.244-3.558-5.974zm0 0"
        fill="#f24049"
      />
      <path
        data-name="Path 273"
        d="M102.35 35.173l1.328-1.9a3.055 3.055 0 00-.747-4.242L64.623 2.205a3.057 3.057 0 00-4.243.748l-1.328 1.9a3.055 3.055 0 00.747 4.242l38.308 26.823a3.057 3.057 0 004.243-.745zm0 0"
        fill="#dde4f7"
      />
      <path
        data-name="Path 274"
        d="M67.363 9.098a3.056 3.056 0 01-.748-4.243l.588-.839-2.579-1.811a3.057 3.057 0 00-4.243.748l-1.329 1.9a3.056 3.056 0 00.748 4.242l38.308 26.823a3.055 3.055 0 004.242-.748l.741-1.058zm0 0"
        fill="#ccd7f2"
      />
      <path
        data-name="Path 275"
        d="M25.668 52.631a9.729 9.729 0 11-9.73-9.73 9.729 9.729 0 019.73 9.73zm0 0"
        fill="#ffcdbe"
      />
      <path
        data-name="Path 276"
        d="M13.691 52.631a9.732 9.732 0 015.988-8.983 9.729 9.729 0 100 17.966 9.731 9.731 0 01-5.988-8.983zm0 0"
        fill="#f7c1b3"
      />
      <path
        data-name="Path 277"
        d="M37.404 60.872c0-.068.005-.133.011-.2l-6.611-1.45a3.739 3.739 0 00-1.771 7.265l8.371 1.878v-7.5zm0 0"
        fill="#ffcdbe"
      />
      <path
        data-name="Path 278"
        d="M33.062 62.784a4.781 4.781 0 011.754-2.681l-4.012-.879a3.739 3.739 0 00-1.771 7.265l5.867 1.316a4.8 4.8 0 01-1.837-5.021zm0 0"
        fill="#f7c1b3"
      />
      <path
        data-name="Path 279"
        d="M97.164 63.33H85.43v7.478h11.734a3.739 3.739 0 000-7.478zm0 0"
        fill="#ffcdbe"
      />
      <path
        data-name="Path 280"
        d="M92.174 63.33H85.43v7.478h6.744zm0 0"
        fill="#f7c1b3"
      />
      <path
        data-name="Path 281"
        d="M83.94 60.728H47.674a2.154 2.154 0 01-.511-.062l-7.757-1.892a2.158 2.158 0 00-2.669 2.1v40.574a2.158 2.158 0 002.158 2.158h45.046a2.158 2.158 0 002.158-2.158V62.887a2.158 2.158 0 00-2.158-2.158zm0 0"
        fill="#003586"
      />
      <path
        data-name="Path 282"
        d="M44.56 101.446V60.872a2.142 2.142 0 01.156-.8l-5.311-1.294a2.158 2.158 0 00-2.669 2.1v40.573a2.158 2.158 0 002.158 2.158h7.824a2.158 2.158 0 01-2.158-2.158zm0 0"
        fill="#4188ff"
      />
      <path
        data-name="Path 283"
        d="M67.496 38.804a1.67 1.67 0 002.326-.41l3.553-5.075a1.67 1.67 0 10-2.736-1.916l-3.553 5.074a1.67 1.67 0 00.41 2.327zm0 0"
      />
      <path
        data-name="Path 284"
        d="M76.088 34.737l-1.206 6.076a1.67 1.67 0 003.277.651l1.206-6.077a1.67 1.67 0 10-3.276-.65zm0 0"
      />
      <path
        data-name="Path 285"
        d="M68.944 27.046a1.669 1.669 0 00-2.294-.562l-5.3 3.212a1.67 1.67 0 101.732 2.856l5.3-3.212a1.669 1.669 0 00.562-2.294zm0 0"
      />
      <path
        data-name="Path 286"
        d="M18.629 33.889a2.272 2.272 0 002 0c1.559-.769 6.644-3.676 6.644-8.789a4.667 4.667 0 00-7.641-3.58 4.669 4.669 0 00-7.644 3.58c0 5.125 5.087 8.024 6.643 8.789zm-.841-9.435a2.136 2.136 0 003.671.013 1.32 1.32 0 012.471.634c0 2.825-2.981 4.8-4.3 5.539-1.321-.734-4.3-2.7-4.3-5.539a1.319 1.319 0 012.462-.647zm0 0"
      />
      <path
        data-name="Path 287"
        d="M31.431 23.075h6.6a1.67 1.67 0 100-3.34h-6.6a1.67 1.67 0 100 3.34zm0 0"
      />
      <path
        data-name="Path 288"
        d="M31.431 28.956h6.6a1.67 1.67 0 000-3.34h-6.6a1.67 1.67 0 000 3.34zm0 0"
      />
      <path
        data-name="Path 289"
        d="M31.431 34.837h6.6a1.67 1.67 0 000-3.34h-6.6a1.67 1.67 0 000 3.34zm0 0"
      />
      <path
        data-name="Path 290"
        d="M110.404 3.342a1.67 1.67 0 000-3.34H93.912a1.668 1.668 0 00-1.456.709L86.69 8.945l-7.313-5.118a16.587 16.587 0 00-13.271-2.57l-.579-.405a4.723 4.723 0 00-6.569 1.158l-1.329 1.9a4.722 4.722 0 001.159 6.569l.456.319a7.822 7.822 0 0011.843 8.293l.933.653a7.821 7.821 0 0011.842 8.293l.933.653a7.822 7.822 0 0011.842 8.29l.458.32a4.722 4.722 0 006.569-1.159l1.329-1.9a4.722 4.722 0 00-1.159-6.569l-.728-.51a16.588 16.588 0 00-6.955-11.592l-6.724-4.709 5.267-7.522zm-47.981 9.681l5.483 3.84a4.463 4.463 0 01-5.483-3.84zm12.775 8.945l5.484 3.84a4.463 4.463 0 01-5.483-3.839zm12.776 8.946l5.484 3.84a4.463 4.463 0 01-5.483-3.839zm14.281 1.413l-1.329 1.9a1.378 1.378 0 01-1.916.338L60.703 7.741a1.384 1.384 0 01-.338-1.916l1.329-1.9a1.384 1.384 0 011.916-.338l38.307 26.824a1.384 1.384 0 01.338 1.916zm-3.319-8.081L70.274 4.176a13.214 13.214 0 017.187 2.388l16.774 11.745a13.217 13.217 0 014.7 5.937zm0 0"
      />
      <path
        data-name="Path 291"
        d="M109.3 69.149h-7.2a5.407 5.407 0 00-5-7.478h-9.6a3.833 3.833 0 00-3.624-2.6H47.618a.526.526 0 01-.116-.014l-7.756-1.892a3.808 3.808 0 00-4.062 1.556l-4.54-1.107a5.42 5.42 0 00-5.874 2.4h-.7a11.366 11.366 0 001.173-13.077h20.325a6.6 6.6 0 006.59-6.597v-9.157a1.67 1.67 0 00-3.34 0v9.157a3.254 3.254 0 01-3.25 3.25H22.814a11.4 11.4 0 00-13.859 0H6.589a3.253 3.253 0 01-3.249-3.25V14.228a3.253 3.253 0 013.249-3.25h39.48a3.253 3.253 0 013.249 3.25v9.161a1.671 1.671 0 003.341 0v-9.161a6.6 6.6 0 00-6.59-6.59H6.589A6.6 6.6 0 000 14.228V40.34a6.6 6.6 0 006.037 6.57 11.363 11.363 0 001.16 13.1h-2.48A4.722 4.722 0 000 64.728v3.046a4.692 4.692 0 001.122 3.046A4.689 4.689 0 000 73.866v3.046a4.719 4.719 0 004.484 4.705v1.472A4.722 4.722 0 009.2 87.806h4.613v21.187A3.186 3.186 0 0017 112.175h3.152a3.186 3.186 0 003.183-3.182V87.806h11.676v13.65a3.832 3.832 0 003.828 3.828h19.278a1.67 1.67 0 100-3.34H38.839a.489.489 0 01-.488-.488V60.892a.213.213 0 000-.023.486.486 0 01.6-.459l7.756 1.892a3.84 3.84 0 00.907.109h36.271a.488.488 0 01.488.488v38.559a.488.488 0 01-.488.488H65.911a1.67 1.67 0 100 3.34h17.974a3.832 3.832 0 003.828-3.828v-13.65h2.974v21.186a3.186 3.186 0 003.183 3.183h3.152a3.186 3.186 0 003.183-3.183V87.806h4.612a4.722 4.722 0 004.717-4.717v-1.473a4.718 4.718 0 004.485-4.7V73.87a4.722 4.722 0 00-4.717-4.717zm-78.946-8.291l4.657 1.136v4.258l-1.975-.482-3.661-.893a2.069 2.069 0 11.98-4.02zm-14.47-.157a8.058 8.058 0 118.059-8.061 8.073 8.073 0 01-8.059 8.061zM3.34 64.728a1.378 1.378 0 011.376-1.376h7.26a11.431 11.431 0 007.815 0h4.684a5.425 5.425 0 004.107 4.771l2.087.509a1.375 1.375 0 01-1.075.518H4.716a1.377 1.377 0 01-1.376-1.376zm0 12.185v-3.046a1.377 1.377 0 011.376-1.375H35.01v5.8H4.716a1.378 1.378 0 01-1.376-1.376zm16.65 31.923h-2.836v-21.03h2.836zM9.2 84.466a1.378 1.378 0 01-1.376-1.376v-1.461H35.01v2.837H9.2zM99.177 67.08a2.07 2.07 0 01-2.068 2.069h-9.4v-4.137h9.4a2.07 2.07 0 012.068 2.068zm-2.313 41.755h-2.836V87.806h2.837zm9.329-25.745a1.378 1.378 0 01-1.376 1.376h-17.1v-2.837h18.48zm4.485-6.177a1.378 1.378 0 01-1.376 1.376H87.713v-5.8H109.3a1.378 1.378 0 011.376 1.376zm0 0"
      />
      <path
        data-name="Path 292"
        d="M7.744 13.711a1.67 1.67 0 00-1.67 1.67V39.19a1.67 1.67 0 001.67 1.67h37.17a1.67 1.67 0 001.67-1.67V15.381a1.67 1.67 0 00-1.67-1.67zm35.5 23.809H9.414V17.052h33.83zm0 0"
      />
    </svg>
  )
}

export default SvgComponent
